import React from 'react';
import './EdModal.scss';

interface EdModalProps {
  isOpen: boolean;
  title: string;
  message: React.ReactNode;
  onClose: () => void;
  buttonText?: string;
}

const EdModal: React.FC<EdModalProps> = ({ isOpen, title, message, onClose, buttonText = 'Got it' }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">{title}</h2>
        <p className="modal-text">{message}</p>
        <div className="modal-actions">
          <button className="modal-button isSecondary" onClick={onClose}>
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EdModal;
